import React, { useState } from 'react';
import { IonTextarea, IonButton, useIonToast } from '@ionic/react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { handleFetchComments, handlePostComments } from 'src/services/PedidoDeProducto/pedido.producto.services';

export interface Comment {
  id: number;
  usuario: string;
  comentario: string;
  fecha: string;
}

interface CommentsDialogProps {
  open: boolean;
  onClose: () => void;
  comments: Comment[];
  getInitials: (name: string) => string;
  onAddComment: (comment: Comment) => void;
  idPC: number; // Recibir id_pc como prop
}

const CommentsDialog: React.FC<CommentsDialogProps> = ({ open, onClose, comments, getInitials, onAddComment, idPC }) => {

  const [newComment, setNewComment] = useState<string>('');
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [present] = useIonToast();

  const handleAddComment = async () => {
    setButtonDisabled(true);

    const comment: Comment | any = {
      comentario: newComment,
    };

    const response = await handlePostComments(idPC, { comentario: comment.comentario });

    if (response) {

      onAddComment(comment); // Añade el comentario a la lista
      setNewComment('');
      present('Comentario guardado con éxito', 2000);
    } else {
      present('Error al guardar el comentario', 2000);
    }

    setButtonDisabled(false);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Comentarios</DialogTitle>
      <DialogContent>
        <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
          {comments.length > 0 ? (
            comments.map((comment) => (
              <React.Fragment key={comment.id}>
                <ListItem alignItems="flex-start">
                  <ListItemAvatar>
                    <Avatar>{getInitials(comment.usuario)}</Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={comment.usuario}
                    secondary={
                      <>
                        <Typography
                          sx={{ display: 'inline' }}
                          component="span"
                          variant="body2"
                          color="text.primary"
                        >
                          {comment.usuario}
                        </Typography>
                        {` — ${comment.comentario}`}
                        <br />
                        <Typography variant="caption" color="text.secondary">
                          {comment.fecha}
                        </Typography>
                      </>
                    }
                  />
                </ListItem>
                <Divider variant="inset" component="li" />
              </React.Fragment>
            ))
          ) : (
            <Typography variant="body2">No hay comentarios disponibles.</Typography>
          )}
        </List>
        <IonTextarea
          placeholder="Ingrese su comentario aquí"
          value={newComment}
          onIonChange={(e) => setNewComment(e.detail.value || '')}
        />
      </DialogContent>
      <DialogActions>
        <IonButton onClick={handleAddComment} disabled={buttonDisabled}>Guardar comentario</IonButton>
        <Button onClick={onClose}>Cerrar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default CommentsDialog;
